import React from "react";
import { Input, Select, Button, Space, Row, Col, Typography } from "antd";
import { Search, Plus, Filter } from "lucide-react";

const { Text } = Typography;

interface LocationFiltersProps {
  onSearch: (value: string) => void;
  onStateFilter: (value: string) => void;
  onAddLocation: () => void;
  states: string[];
  totalLocations: number;
}

const LocationFilters: React.FC<LocationFiltersProps> = ({
  onSearch,
  onStateFilter,
  onAddLocation,
  states,
  totalLocations,
}) => {
  return (
    <Space direction="vertical" style={{ width: "100%" }} size="middle">
      <Row gutter={[16, 16]} align="middle">
        <Col flex="auto">
          <Input
            prefix={<Search size={16} />}
            placeholder="Search locations..."
            onChange={(e) => onSearch(e.target.value)}
          />
        </Col>
        <Col>
          <Select
            allowClear
            placeholder="Filter by state"
            onChange={onStateFilter}
            style={{ minWidth: 150 }}
            options={states.map((state) => ({ label: state, value: state }))}
            suffixIcon={<Filter size={16} />}
          />
        </Col>
        <Col>
          <Button
            type="primary"
            icon={<Plus size={12} />}
            onClick={onAddLocation}
          >
            Add Location
          </Button>
        </Col>
      </Row>

      <Text type="secondary">{totalLocations} locations found</Text>
    </Space>
  );
};

export default LocationFilters;
